<template>
  <div>
    <div class="input-label">SEO Title</div>
    <div class="input-box">
      <input type="text" placeholder="SEO Title" v-model="value.seoTitle" :disabled="value.disable">
    </div>
    <div class="input-label">SEO Description</div>
    <div class="input-box">
      <input type="text" placeholder="SEO Description" v-model="value.seoDescription" :disabled="value.disable">
    </div>
  </div>
</template>

<script>
export default {
  props: {
            value: {
            }
        },
        watch: {
            value() {
                this.$emit('input', this.value);
            }
        }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// seoTagInput.vue?69799450